import forEach from "lodash/forEach";

function replaceLink(urlText, linkText) {
    if (urlText.indexOf('youtu.be') > -1 || urlText.indexOf('youtube.com/watch') > -1) {
        return youtube(urlText);
    } else {
        return `<a href="${urlText}" target="_blank">${linkText}</a>`;
    }
}

function replaceAllUrls (text) {
    // TODO: Catching src links.... fix
    const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])(?!abc)/ig;
    return text.replace(urlRegex, url => {
        if (url.indexOf('youtu.be') > -1 || url.indexOf('youtube.com/watch') > -1) {
            return youtube(url);
        }
        if (text.indexOf('href="' + url) > -1) {
            return url;
        } else {
            const newLink = `<a href="${url}" target="_blank">${url}</a>`;
            return newLink;
        }
    });
}

function youtube( url ) {
    let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|live\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    let match = url.match(regExp);
    if (match && match[2].length === 11) {
        return '<iframe width="560" height="315" src="//www.youtube.com/embed/' + match[2] + '" frameborder="0" allowfullscreen></iframe>';
    }

    // https://www.youtube.com/live/uzgIkzrEUeg?feature=share

    // Didn't return. Check the next type of link
    regExp = /^.*(youtube.com\/|v\/|u\/\w\/|embed\/|live\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    match = url.match(regExp);
    if (match && match[2].length === 11) {
        return '<iframe width="560" height="315" src="//www.youtube.com/embed/' + match[2] + '" frameborder="0" allowfullscreen></iframe>';
    }
    return url;
}

export function replaceMentionLink(link) {
    const replacement = link.replace("href=", "data-id=").replace('class="', 'class="mention ');
    return replacement;
}

export function postify(text) {
    /*
    * Quill editor automatically wraps links when the user hits return
    * <a href=[url]>[url]</a>
    * Be sure to remove the tag if it's YouTube
    */
    if (!text) {
        return text;
    }

    let modifiedText = '';
    if (text.indexOf('<a ') !== -1) {
        // If text contains an <a tag, replace the whole thing
        modifiedText = text;
        let hasLink = true;
        let lastIndex = 0;
        let loopIndex = 0;
        while(hasLink && loopIndex < 20) {
            // process all the links
            const linkStart = lastIndex + modifiedText.substring(lastIndex).indexOf('<a ');
            const linkEnd = lastIndex + modifiedText.substring(lastIndex).indexOf('</a>') + 4;
            const textBefore = modifiedText.slice(0, linkStart);
            const textAfter = modifiedText.slice(linkEnd);

            const link = modifiedText.slice(linkStart, linkEnd);
            let linkReplacement = '';
            const splitLink = link.split('href="');
            let linkUrl = splitLink[1].split('"')[0];
            const linkText = link.split('>')[1].split('<')[0];

            if (link.indexOf('data-mention') !== -1) {
                // This is a mention/tag
                linkReplacement = replaceMentionLink(link);
            } else {
                linkReplacement = replaceLink(linkUrl, linkText);
            }

            modifiedText = `${textBefore}${linkReplacement}${textAfter}`;

            lastIndex = textBefore.length + linkReplacement.length;
            hasLink = (modifiedText.substring(lastIndex).indexOf('<a ') > -1); // Do it again?
            loopIndex++;
        }
    }
    modifiedText = replaceAllUrls(modifiedText||text);

    return replaceHashtags(modifiedText.replace('#caret', ''));
}

const HASHTAG_REGEX = /(^|[\s>"'(])#([A-Za-z0-9_][A-Za-z0-9_-]{0,99})/g;

export function parseHashtagQuery(query) {
    if (!query) return null;
    const match = query.trim().match(/^#([A-Za-z0-9_][A-Za-z0-9_-]{0,99})$/);
    return match ? match[1].toLowerCase() : null;
}

export function replaceHashtags(text) {
    if (!text) return text;
    const linkRegex = /(<a\s[^>]*>[\s\S]*?<\/a>)/gi;
    const parts = text.split(linkRegex);
    return parts.map((part) => {
        if (/^<a\s/i.test(part)) return part;
        return part.replace(HASHTAG_REGEX, (match, prefix, name) => {
            if (name.toLowerCase() === "caret") return match;
            const slug = name.toLowerCase();
            return `${prefix}<a class="hashtag" href="/app/hashtag/${slug}" data-hashtag="${slug}">#${name}</a>`;
        });
    }).join("");
}

export function handleHashtagClick(event, history) {
    const link = event.target.closest && event.target.closest("a.hashtag");
    if (!link || !history) return;
    event.preventDefault();
    event.stopPropagation();
    const name = link.getAttribute("data-hashtag");
    if (name) history.push(`/hashtag/${name}`);
}

/**
 * Replaces video timestamp patterns (e.g. 3:35, 1:23:45, "minute 3:35") with clickable spans.
 * Does not replace inside existing <a> tags. Use after postify() when the post has video.
 */
export function replaceVideoTimestamps(text) {
    if (!text) return text;
    const linkRegex = /(<a\s[^>]*>[\s\S]*?<\/a>)/gi;
    const parts = text.split(linkRegex);
    // Match M:SS or H:MM:SS (optional "minute " or "at " before)
    const timeRegex = /(?:minute\s+|at\s+)?\b(\d{1,2}):(\d{2})(?::(\d{2}))?\b/gi;
    const out = parts.map((part) => {
        if (/^<a\s/i.test(part)) return part;
        return part.replace(timeRegex, (match, g1, g2, g3) => {
            const seconds = g3 !== undefined
                ? parseInt(g1, 10) * 3600 + parseInt(g2, 10) * 60 + parseInt(g3, 10)
                : parseInt(g1, 10) * 60 + parseInt(g2, 10);
            return `<span class="video-timestamp" data-seconds="${seconds}">${match}</span>`;
        });
    });
    return out.join("");
}

export const SEEK_VIDEO_EVENT = "jazzwire:seekVideo";

export function addListenersToVideoTimestamps(containerEl, onSeek) {
    if (!containerEl || !onSeek) return;
    const nodes = containerEl.querySelectorAll(".video-timestamp");
    forEach(nodes, (el) => {
        el.addEventListener("click", (e) => {
            e.preventDefault();
            const sec = el.getAttribute("data-seconds");
            if (sec != null) onSeek(parseInt(sec, 10));
        });
    });
}

export function addListenersToMentions(currentContent, postText, setUserId) {
    if (postText.indexOf("mention") !== -1 && currentContent) {
        const mentionLinks = currentContent.getElementsByClassName("mention");
        forEach(mentionLinks, link => {
            const userStudioId = link.getAttribute("data-id");
            link.addEventListener("click", () => {
                setUserId(userStudioId);
            });
        });
    }
}